
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface SubmitButtonProps {
  submitting: boolean;
}

const SubmitButton: React.FC<SubmitButtonProps> = ({ submitting }) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  
  const handleClick = () => {
    setShowConfirmation(true);
  };

  return (
    <>
      <Button 
        type="button" 
        className="w-full bg-brand-primary hover:bg-brand-primary/90 text-brand-primary-foreground"
        disabled={submitting}
        onClick={handleClick}
      >
        {submitting ? 'Sender...' : 'Send inn'}
      </Button>
      
      <AlertDialog open={showConfirmation} onOpenChange={setShowConfirmation}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Bekreft innsending</AlertDialogTitle>
            <AlertDialogDescription>
              Er du sikker på at du vil sende inn intervjusvaret ditt? Etter innsending vil du ikke kunne gjøre endringer.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="bg-gray-100 hover:bg-gray-200 text-gray-900 border border-gray-300">
              Avbryt
            </AlertDialogCancel>
            <AlertDialogAction 
              type="submit" 
              form="interview-form"
              className="bg-green-600 hover:bg-green-700 text-white"
            >
              Bekreft innsending
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default SubmitButton;
